import { formatCurrencyAmount as _formatCurrencyAmount } from 'lib';

/* ── Status styles ──────────────────────────────────────── */

export const STATUS_STYLES = {
  active: { dot: 'bg-emerald-400', bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200' },
  success: { dot: 'bg-emerald-400', bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200' },
  cancelled: { dot: 'bg-red-400', bg: 'bg-red-50', text: 'text-red-600', border: 'border-red-200' },
  retrying: { dot: 'bg-amber-400', bg: 'bg-amber-50', text: 'text-amber-700', border: 'border-amber-200' },
  suspended: { dot: 'bg-red-400', bg: 'bg-red-50', text: 'text-red-600', border: 'border-red-200' },
  pending: { dot: 'bg-slate-300', bg: 'bg-slate-50', text: 'text-slate-500', border: 'border-slate-200' },
  failed: { dot: 'bg-red-400', bg: 'bg-red-50', text: 'text-red-600', border: 'border-red-200' },
  deleted: { dot: 'bg-slate-300', bg: 'bg-slate-50', text: 'text-slate-500', border: 'border-slate-200' },
  approved: { dot: 'bg-emerald-500', bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200' },
  rejected: { dot: 'bg-red-500', bg: 'bg-red-50', text: 'text-red-600', border: 'border-red-200' },
  refunded: { dot: 'bg-blue-400', bg: 'bg-blue-50', text: 'text-blue-700', border: 'border-blue-200' }
};

/* ── Event styles ───────────────────────────────────────── */

export const EVENT_STYLES = {
  subscribed: { color: '#10b981', bg: 'bg-emerald-50', border: 'border-emerald-100' },
  renewed: { color: '#10b981', bg: 'bg-emerald-50', border: 'border-emerald-100' },
  upgraded: { color: '#3b82f6', bg: 'bg-blue-50', border: 'border-blue-100' },
  downgraded: { color: '#f59e0b', bg: 'bg-amber-50', border: 'border-amber-100' },
  payment_succeeded: { color: '#10b981', bg: 'bg-emerald-50', border: 'border-emerald-100' },
  payment_failed: { color: '#ef4444', bg: 'bg-red-50', border: 'border-red-100' },
  renewal_failed: { color: '#ef4444', bg: 'bg-red-50', border: 'border-red-100' },
  cancelled: { color: '#ef4444', bg: 'bg-red-50', border: 'border-red-100' },
  suspended: { color: '#ef4444', bg: 'bg-red-50', border: 'border-red-100' },
  checkout_initiated: { color: '#94a3b8', bg: 'bg-slate-50', border: 'border-slate-100' }
};

/* ── Formatters ─────────────────────────────────────────── */

export function formatDate(date) {
  if (!date) return '-';
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

export function formatDateTime(date) {
  if (!date) return '-';
  const d = new Date(date);
  const datePart = d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
  const timePart = d.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit'
  });
  return `${datePart} at ${timePart}`;
}

export function formatAmount(value, currency) {
  if (value == null) return '-';
  const normalized = Number.isInteger(value) ? value : value.toFixed(2);
  return _formatCurrencyAmount(normalized, currency);
}
